// extracted by mini-css-extract-plugin
export var askAiIcon = "_ml-j";
export var category = "_ml-9";
export var categoryHeader = "_ml-e";
export var container = "_ml-0";
export var group = "_ml-a";
export var groupItems = "_ml-f";
export var groupSeparator = "_ml-k";
export var loading = "_ml-1";
export var noResults = "_ml-3";
export var placeholder = "_ml-2";
export var resultContent = "_ml-5";
export var resultIcon = "_ml-c";
export var resultItem = "_ml-g";
export var resultMeta = "_ml-8";
export var resultSubtitle = "_ml-7";
export var resultSuffix = "_ml-i";
export var resultTitle = "_ml-6";
export var resultsList = "_ml-4";
export var searchGroup = "_ml-d";
export var selected = "_ml-h";
export var subgroup = "_ml-b";